import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, UrlTree, DefaultUrlSerializer } from '@angular/router';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';
import { Location } from '@angular/common';
import { merge } from 'rxjs';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-login-combined-edu-gov',
  templateUrl: './login-combined-edu-gov.component.html',
  styleUrls: ['./login-combined-edu-gov.component.scss']
})

export class LoginCombinedEduGovComponent implements OnInit {
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private location: Location,private appService:AppServiceService) { }

  ngOnInit(): void {
    this.appService.componentName = 'login-combined-edu-gov-component';
  }

  routingToFormLogin() {
    window.location.href = window['_loginMethodUsernameSMSOTPURL'];
  }

  redirectGov(){
    window.location.href = window['_govIDPLoginUrl'];
  }

}
